import React from "react";
import {
  Breadcrumbs,
  Card,
  Chip,
  Container,
  Grid,
  Typography,
} from "@mui/material";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Divider from "@mui/material/Divider";
import Lightbox from "react-image-lightbox";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { styled } from "@mui/material/styles";
import { Link, useParams } from "react-router-dom";
import { useGetProductByIdMutation } from "../redux/reducer/features/Product/productSlice";
import { Colors, Product } from "../models/features/Product/Product";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

export interface DetailProps {}
export const ProductDetails: React.FunctionComponent<DetailProps> = () => {
  let { id } = useParams();
  const [productDetail, setProductDetail] = React.useState<Product>();
  const [detailMutation, detailMutationResult] = useGetProductByIdMutation();
  const [URL, setURL] = React.useState("");
  const [isOpen, setOpen] = React.useState(false);

  React.useEffect(() => {
    detailMutation({ data: { id: id } });
  }, []);
  const handleLightBoxOpen = () => {
    setOpen(true);
  };
  const handleLightBoxClose = () => {
    setOpen(false);
  };
  React.useEffect(() => {
    if (detailMutationResult.data) {
      setProductDetail(detailMutationResult.data.entity);
    }
  }, [detailMutationResult]);

  console.log(id);
  return (
    <Container maxWidth={false}>
      <Card style={{ padding: "10px", margin: "10px" }}>
        <Breadcrumbs aria-label="breadcrumb">
          <Link color="inherit" to="/">
            Dashboard
          </Link>
          <Link color="inherit" to="/Products">
            Products
          </Link>
          <Typography color="text.primary">Product Detail</Typography>
        </Breadcrumbs>
      </Card>
      <Card style={{ padding: "10px", margin: "10px" }}>
        <Grid container spacing={4} justifyContent="flex-start">
          <Grid item xs={12} md={6} pr={2}>
            {productDetail && productDetail?.images ? (
              <Carousel width={"100%"}>
                {productDetail?.images.map((img) => {
                  return (
                    <div
                      onClick={() => {
                        handleLightBoxOpen();
                        setURL(img?.absoluteUrl ?? "");
                      }}
                    >
                      <img
                        style={{ width: "100%" }}
                        src={img?.absoluteUrl}
                      ></img>
                    </div>
                  );
                })}
              </Carousel>
            ) : (
              ""
            )}
          </Grid>
          <Grid
            item
            mt={4}
            xs={12}
            md={6}
            sx={{
              border: "1px solid #dee2e6 !important",
              minHeight: "70vh",
            }}
          >
            <Typography
              variant="h4"
              sx={{ fontWeight: 700, textTransform: "uppercase" }}
            >
              {productDetail?.title}
            </Typography>
            <Typography
              mt={2}
              mb={3}
              sx={{
                textTransform: "uppercase",
                color: "#6c757d !important",
                fontSize: 13,
              }}
            >
              SEE MORE BY: {productDetail?.category?.title}
            </Typography>
            <Divider />
            <Typography
              mt={3}
              mb={3}
              sx={{ fontWeight: 700, fontSize: "1.5rem" }}
            >
              Product Overview
            </Typography>
            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography sx={{ fontWeight: 700 }}>Description</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                  <span
                    dangerouslySetInnerHTML={{
                      __html:
                        productDetail && productDetail.description
                          ? productDetail?.description
                          : "",
                    }}
                  ></span>
                </Typography>
              </AccordionDetails>
            </Accordion>
            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel2a-content"
                id="panel2a-header"
              >
                <Typography sx={{ fontWeight: 700 }}>
                  Weight & Dimension
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Table aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell>Height</TableCell>
                      <TableCell align="right">Weight</TableCell>
                      <TableCell align="right">Length</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow
                      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                    >
                      <TableCell component="th" scope="row">
                        {productDetail?.dimension?.height}in
                      </TableCell>
                      <TableCell align="right">
                        {productDetail?.dimension?.weight}lbs
                      </TableCell>
                      <TableCell align="right">
                        {productDetail?.dimension?.depth}in
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </AccordionDetails>
            </Accordion>
            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel3a-content"
                id="panel3a-header"
              >
                <Typography sx={{ fontWeight: 700 }}>Specifications</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Table aria-label="customized table">
                  <TableBody>
                    {/* <StyledTableRow>
                      <StyledTableCell component="th">Model Id</StyledTableCell>
                      <StyledTableCell>
                        {productDetail?.productId}
                      </StyledTableCell>
                    </StyledTableRow> */}
                    <StyledTableRow>
                      <StyledTableCell>Model</StyledTableCell>
                      <StyledTableCell>
                        {productDetail?.modelNumber}
                      </StyledTableCell>
                    </StyledTableRow>
                    {/* <StyledTableRow>
                      <StyledTableCell>Model Name</StyledTableCell>
                      <StyledTableCell>
                        {productDetail?.modelName}
                      </StyledTableCell>
                    </StyledTableRow> */}
                    <StyledTableRow>
                      <StyledTableCell>SKU</StyledTableCell>
                      <StyledTableCell>{productDetail?.sku}</StyledTableCell>
                    </StyledTableRow>
                    <StyledTableRow>
                      <StyledTableCell>Year</StyledTableCell>
                      <StyledTableCell>{productDetail?.year}</StyledTableCell>
                    </StyledTableRow>
                    <StyledTableRow>
                      <StyledTableCell>Product Category </StyledTableCell>
                      <StyledTableCell>
                        {productDetail?.category?.title}
                      </StyledTableCell>
                    </StyledTableRow>
                    <StyledTableRow>
                      <StyledTableCell>Product Subcategory </StyledTableCell>
                      <StyledTableCell></StyledTableCell>
                    </StyledTableRow>
                    <StyledTableRow>
                      <StyledTableCell>Power Type </StyledTableCell>
                      <StyledTableCell>
                        {productDetail?.powerType}
                      </StyledTableCell>
                    </StyledTableRow>
                    <StyledTableRow>
                      <StyledTableCell>Color</StyledTableCell>
                      <StyledTableCell>
                        {productDetail && productDetail.colors
                          ? productDetail.colors.map((item: Colors) => (
                              <Chip label={item.title} />
                            ))
                          : ""}
                      </StyledTableCell>
                    </StyledTableRow>
                    <StyledTableRow>
                      <StyledTableCell>Tags</StyledTableCell>
                      <StyledTableCell>
                        {productDetail && productDetail.tags
                          ? productDetail.tags.map((item: any) => (
                              <Chip label={item} />
                            ))
                          : ""}
                      </StyledTableCell>
                    </StyledTableRow>
                  </TableBody>
                </Table>
              </AccordionDetails>
            </Accordion>
          </Grid>
        </Grid>{" "}
      </Card>
      {isOpen && (
        <Lightbox mainSrc={URL} onCloseRequest={handleLightBoxClose} />
      )}
    </Container>
  );
};
